<pos-app-spinner [displayText]="generateReportLoaderText" [showTextLoader]="showTextLoader" [show]="generateQuoteloading$ | async"></pos-app-spinner>
<pos-app-spinner
  [show]="(orderLoading$ | async) || (validatingOrder$ | async) || (addItemProcessed$ | async) || (isLoadingHeader$ | async) || (isLoadingPayments$ | async)"
></pos-app-spinner>
<div *ngIf="addItemProcessed$ | async as processed" class="progress">Processed {{ processed }} items</div>

<div
  *ngIf="
    orderHeader && {
      isExternalUser: isExternalUser$ | async,
      loadingLines: loadingLines$ | async,
      orderValidated: orderValidated$ | async,
      paymentInfo: paymentInfo$ | async,
      depositAmount: depositAmount$ | async,
      isProgrammeUser: isProgrammeUser$ | async
    } as data
  "
>
  <div [hidden]="isMakingPayments || isSaving">
    <div class="mx-2">
      <div class="text-center">
        <h3 class="pt-3 arb-large-heading text-uppercase">{{ orderHeaderText }} details</h3>
      </div>

      <div>
        <app-order-header-click-and-collect
          #orderHeaderComponent
          [orderHeader]="orderHeader"
          [headerMessages]="headerMessages$ | async"
          [branchList]="branchList"
          [nonCorpStoreList]="nonCorpStoreList"
          [orderTypeList]="orderTypeList"
          [nonCorpOrderTypeList]="nonCorpOrderTypeList"
          [isExternalUser]="data.isExternalUser"
          [isProgrammeUser]="data.isProgrammeUser"
          [isVehicleDataReady]="!(loadingCustomerDetails$ | async) && !(loadingLookupLists$ | async)"
          [isCreditOrder]="isCreditOrder"
          [creditReasonList]="creditReasonList"
          [selectedReasonCode]="selectedCreditReason"
          [isShowUser]="isShowUser()"
          [customerType]="selectedCustomer?.customerType"
          [hasCashDrawer]="!!isCashDrawerOpen"
          [selectedCustomer]="selectedCustomer"
          [allAttachments]="allAttachments"
          (useVehicleColourForAll)="onUseVehicleColourForAll()"
          (isHeaderValid)="isHeaderValid = $event"
          (isOrderOnHold)="isOrderOnHold = $event"
          (selectReason)="onSelectCreditReason($event)"
          (headersToUpdate)="updateHeaders($event)"
          (loadAllAttachments)="loadAllAttachments()"
        ></app-order-header-click-and-collect>
      </div>

      <div class="order-grid">
        <app-order-grid-click-and-collect
          #orderGridComponent
          [gridResult]="orderDetails"
          [orderHeader]="orderHeader"
          [orderMessages]="orderMessages$ | async"
          [isUpdatingStagingCompleted]="isUpdatingStagingCompleted"
          [isExternalUser]="data.isExternalUser"
          [isProgrammeUser]="data.isProgrammeUser"
          [cashDrawer]="isCashDrawerOpen"
          [viewSettings]="viewSettings"
          [isCreditOrder]="isCreditOrder"
          [isConvertToOrder]="isConvertToOrder"
          [selectedCreditReason]="selectedCreditReason"
          [cancelAllLinesAllowed]="cancelAllLinesAllowed"
          [displayOptions]="displayOptions"
          [brandDefaults]="brandDefaults$ | async"
          [userSecurityFunctions]="userSecurityFunctions"
          [isOrderValidated]="isOrderValidated"
          [isShowUser]="isShowUser()"
          [depositAmount]="data.depositAmount"
          [dispatchList]="dispatchList"
          [creditList]="creditList"
          [orderLoading]="orderLoading$ | async"
          (showDetailedAvailability)="availabilityItem = $event"
          (hasInvalidItem)="hasInvalidItem = $event"
          (enableValidateOrder)="enableValidateOrder = $event"
          (copyOrder)="copyOrder()"
          (isCellStartEditing)="toggleDisableConfirmButton($event)"
          (deletingAllItems)="onDeleteAllItems()"
          (dispatchedItems)="onDispatchedItems($event)"
          (dispatchAll)="onDispatchAll($event)"
          (addItemsToOrder)="addItemsToOrder($event)"
          (viewSettingsChange)="onViewSettingsChange($event)"
          (lineUpdated)="lineUpdated()"
          (cellEdited)="updateCell($event)"
          (loadStagingOrder)="loadStagingOrder()"
          (openOrderNote)="orderHeaderComponent.openNotesModal()"
          [allAttachments]="allAttachments"
          (hasInvalidMessageError)="checkHasInvalidMessageError($event)"
        ></app-order-grid-click-and-collect>
      </div>

      <div class="pb-5 pt-3 row order-total">
        <div class="col-8 col-lg-6 col-xl-5">
          <app-order-total
            *ngIf="
              (!data.isExternalUser && !data.isProgrammeUser) ||
              ((data.isExternalUser || data.isProgrammeUser) && orderHeader.orderType === ORDER_TYPE.quoteOrder) ||
              userSecurityFunctions.includes(SEE_BUY_PRICE)
            "
            [depositAmount]="data.depositAmount"
            [dispatchList]="dispatchList"
            [orderDetails]="orderDetails"
            [isQuoteOrder]="isConvertToOrder"
            [viewSettings]="viewSettings"
            [currencyCode]="orderHeader.currencyCode"
            [orderClass]="'ClickAndCollect'"
          ></app-order-total>
        </div>

        <div class="col-12 col-xl-7">
          <table class="table table-borderless table-responsive d-flex justify-content-start justify-content-xl-end actions">
            <tbody>
              <tr>
                <td
                  *ngIf="
                    orderHeader?.readOnlyYN === 'N' &&
                    (orderHeader?.jobRequestOrderStatus === ORDER_STATUS.acknowledgeOrder ||
                      orderHeader?.jobRequestOrderStatus === ORDER_STATUS.ecomQuote)
                  "
                >
                  <button type="button" class="btn text-white order-buttons" (click)="acknowledgeOrderORQuote()" [disabled]="disableConfirmOrder()">
                    ACKNOWLEDGE {{ orderHeader?.orderType === ORDER_TYPE.quoteOrder ? 'QUOTE' : 'ORDER' }}
                  </button>
                </td>

                <td
                  *ngIf="orderHeader?.readOnlyYN === 'N' && orderHeader?.jobRequestOrderStatus === ORDER_STATUS.printPick && userRole === 'INTERNAL'"
                >
                  <button type="button" class="btn text-white order-buttons" (click)="printPick()" [disabled]="disableConfirmOrder()">
                    PRINT PICK
                  </button>
                </td>
                <td
                  *ngIf="
                    orderHeader?.readOnlyYN === 'N' && orderHeader?.jobRequestOrderStatus === ORDER_STATUS.rePrintPick && userRole === 'INTERNAL'
                  "
                >
                  <button type="button" class="btn text-white order-buttons" (click)="printPick()" [disabled]="disableConfirmOrder()">
                    REPRINT PICK
                  </button>
                </td>
                <td *ngIf="orderHeader?.readOnlyYN === 'N' && orderHeader?.jobRequestOrderStatus === ORDER_STATUS.notifyCustomerPickup">
                  <button type="button" class="btn text-white order-buttons" (click)="confirmAllStock()" [disabled]="disableConfirmOrder()">
                    CONFIRM STOCK AND NOTIFY CUSTOMER TO PICK UP
                  </button>
                </td>
                <td
                  *ngIf="orderHeader?.readOnlyYN === 'N' && (orderHeader?.jobRequestOrderStatus === 40 || orderHeader?.jobRequestOrderStatus === 50)"
                >
                  <button
                    type="button"
                    class="btn text-white order-buttons"
                    [disabled]="dispatchList.length <= 0 || disableSaveGood(data.loadingLines)"
                    (click)="
                      orderHeader?.jobRequestOrderStatus === 40 || orderHeader?.jobRequestOrderStatus === 50
                        ? confirmIdentityForCollection()
                        : sellGoods()
                    "
                  >
                    CONFIRM CUSTOMER COLLECTED
                  </button>
                </td>
                <td>
                  <button type="button" class="btn btn-cancel order-buttons text-uppercase" (click)="cancelOrder(orderHeader.orderNumber)">
                    CLOSE
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isMakingPayments || isSaving" class="container-fluid pb-2">
    <mat-horizontal-stepper linear #stepper>
      <mat-step *ngIf="!isSaving && !toDisableAllocation">
        <ng-template matStepLabel>STOCK ALLOCATION</ng-template>
        <app-orders-stock-allocation
          [showLocation]="isShowUser() ? showLocation : null"
          [isCreditOrder]="isCreditOrder"
          [isnonCorpClickAndCollect]="orderHeader?.nonCorpStoreSaleYN === 'Y'"
          [stockList]="stockAllocationList"
          (allocateStock)="allocateStock($event)"
          (isSerialNumberExist)="isSerialNumberExist($event)"
        ></app-orders-stock-allocation>
        <div class="mt-4 d-flex justify-content-end">
          <button mat-button class="btn text-white" [disabled]="!isValidAllocation || isSerialNumberOnHand" (click)="goToPayment()">
            {{ completeClickAndCollectOrderTF ? 'COMPLETE ORDER' : 'NOTIFY CUSTOMER' }}
          </button>
          <span class="px-2"></span>
          <button class="btn btn-cancel" (click)="onReturnToOrder()">RETURN TO ORDER</button>
        </div>
      </mat-step>

      <mat-step *ngIf="!isSaving && giftCardLoadUpList?.length > 0">
        <ng-template matStepLabel>LOAD UP GIFT CARD</ng-template>
        <div>
          <app-orders-gift-card-loadup
            [orderNumber]="orderNumber"
            [giftCardLoadUpList]="giftCardLoadUpList"
            (cardLoadedEmit)="onCardLoaded($event)"
          ></app-orders-gift-card-loadup>
        </div>
        <div class="mt-4 d-flex justify-content-end">
          <button mat-button matStepperPrevious class="btn text-white">BACK</button>
          <span class="px-2"></span>
          <button mat-button matStepperNext class="btn text-white" [disabled]="(pendingLoadAmounts$ | async)?.length > 0">NEXT</button>
          <span class="px-2"></span>
          <button class="btn btn-cancel" (click)="onReturnToOrder()">RETURN TO ORDER</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>NOTIFY CUSTOMER</ng-template>
        <div>
          <app-order-distribute
            [orderType]="orderHeader.orderType"
            [printerList]="printerList"
            [userDetails]="userDetails"
            [selectedCustomer]="selectedCustomer"
            [userRole]="userRole"
            [orderConfirmation]="orderConfirmation"
            [isQuickSale]="orderHeader.quickSaleYN === 'Y'"
            [isCreditOrder]="isCreditOrder"
            [cashPaymentData]="{
              cashChange: data.paymentInfo?.totals?.cashChange,
              cashTendered: data.paymentInfo?.totals?.cashTendered
            }"
            [isReceiptPrinterConnected]="drawerService.getIsPrinterConnected()"
            (distributeOrderData)="distributeOutputData = $event"
            (updateEmail)="updateCustomerEmail($event)"
            (allowToFinalise)="allowToFinalise = $event"
            (setIncompleteOrder)="setIncompleteOrder()"
          ></app-order-distribute>
        </div>
        <div class="mt-4 d-flex justify-content-end">
          <span class="px-2"></span>
          <button mat-button matStepperPrevious class="btn text-white" *ngIf="!isSaving">BACK</button>
          <span class="px-2"></span>
          <button
            *ngIf="!data.isExternalUser && !data.isProgrammeUser"
            mat-button
            class="btn text-white"
            (click)="completeOrder(isMakingPayments)"
            [disabled]="!allowToFinalise"
          >
            FINALISE SALE
          </button>
          <button
            *ngIf="data.isExternalUser || data.isProgrammeUser"
            mat-button
            class="btn text-white"
            (click)="completeOrder(isMakingPayments)"
            [disabled]="!allowToFinalise"
          >
            {{ orderHeader.orderType === ORDER_TYPE.quoteOrder ? 'PRODUCE QUOTE' : 'SEND ORDER TO ARB' }}
          </button>
          <span class="px-2"></span>
          <button class="btn btn-cancel" (click)="onReturnToOrder()">RETURN TO ORDER</button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>

<div *ngIf="isCheckingCreditUser">
  <app-orders-check-credit-users (isCreditUser)="handleCreditUser($event)"></app-orders-check-credit-users>
</div>

<div *ngIf="availabilityItem">
  <app-orders-detailed-availability
    [availabilityItem]="availabilityItem"
    [branchList]="branchList"
    [orderHeader]="orderHeader"
    (cancelAvailabilityView)="cancelAvailabilityView()"
  >
  </app-orders-detailed-availability>
</div>

<ng-template #content>
  <div *ngIf="isSelectPrinter">
    <app-lib-customer-printer-selector
      [printerList]="printerList"
      (selectPrinter)="onSelectPrinter($event)"
      [orderClass]="'ClickAndCollect'"
      [orderNumber]="orderHeader?.orderNumber"
      (closeActiveModal)="close()"
    ></app-lib-customer-printer-selector>
  </div>

  <div *ngIf="!isSelectPrinter && !isGatherInvoiceDetails && !isConfirmingIdentityForCollection">
    <ng-container *ngIf="!isShowUser(); else overrideForShow">
      <app-orders-override-branch
        [overridenBranch]="overrideData.overrideBranch"
        [branchList]="branchList"
        [isConvertToOrder]="isConvertToOrder"
        (selectOverridenBranch)="onSelectOverrideData($event)"
      ></app-orders-override-branch>
    </ng-container>
    <ng-template #overrideForShow>
      <app-orders-override-show
        [salesPerson]="orderHeader.salesperson"
        [showBranch]="overrideData.overrideBranch"
        [orderBranch]="orderHeader.dispatchFrom"
        [shipTo]="orderHeader.shipToNumber"
        [branchList]="branchList"
        [nonCorpStoreList]="nonCorpStoreList"
        [showUsers]="showUsers"
        [nonCorpStoreSale]="orderHeader.nonCorpStoreSaleYN === 'Y'"
        (selectForShow)="onSelectOverrideData($event)"
      ></app-orders-override-show>
    </ng-template>
  </div>
  <div *ngIf="isGatherInvoiceDetails">
    <div class="modal-header">
      <h3 class="arb-large-heading" id="modal-basic-title">Required Information</h3>
    </div>
    <div>
      <div class="modal-body">
        <!-- input for invoice number and references -->
        <div class="form-group">
          <label for="invoiceNumber">Enter your invoice number</label>
          <input
            maxlength="25"
            type="text"
            class="form-control"
            id="invoiceNumber"
            [(ngModel)]="invoiceNumber"
            (ngModelChange)="invoiceDetailsValid = invoiceNumber?.length > 0"
          />
        </div>
        <div class="form-group">
          <label for="deliveryReference">Enter Con or delivery reference (if available)</label>
          <input
            maxlength="20"
            type="text"
            class="form-control"
            id="deliveryReference"
            [(ngModel)]="deliveryReference"
            (ngModelChange)="invoiceDetailsValid = invoiceNumber?.length > 0"
          />
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-cancel" (click)="isGatherInvoiceDetails = false; close()">CANCEL</button>
        <button type="button" class="btn text-white" [disabled]="!invoiceDetailsValid" (click)="isGatherInvoiceDetails = false; sellGoods()">
          SUBMIT
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="isConfirmingIdentityForCollection">
    <div class="modal-header">
      <h3 class="arb-large-heading" id="modal-basic-title">Identity Confirmation Required</h3>
    </div>
    <div>
      <div class="modal-body d-flex justify-content-center align-items-center">
        <!-- adding checkbox for E-Commerce order number confirmation -->
        <input class="form-check-input m-2" type="checkbox" id="ecommerceOrderNumber" [(ngModel)]="isEcommerceOrderNumberConfirmed" />
        <div>
          E-Commerce order number <label style="font-weight: 600">{{ orderHeader?.reference }}</label> confirmed with the customer
        </div>
      </div>
      <div class="modal-body d-flex justify-content-evenly align-items-center">
        <!-- select type of identification for order collection -->
        <div class="form-group mx-2 px-2">
          <label for="identityType">Identification presented by the customer</label>
          <ng-select id="identityType" [(ngModel)]="identityType" [multiple]="true" (ngModelChange)="identityTypeValid = identityType?.length > 0">
            <ng-option value="" disabled selected>Select identification type</ng-option>
            <ng-option value="drivers license">Driver's License</ng-option>
            <ng-option value="passport">Passport</ng-option>
            <ng-option value="proof of address">Proof of Address</ng-option>
            <ng-option value="SMS collections text">SMS collection text</ng-option>
          </ng-select>
        </div>
        <div class="form-group mx-2 px-2">
          <div>
            <!-- personWhoCollectedGoods  -->
            <div class="form-group ml-3">
              <label for="personWhoCollectedGoods">Collected By</label>
              <input
                maxlength="50"
                type="text"
                class="form-control"
                id="personWhoCollectedGoods"
                [(ngModel)]="personWhoCollectedGoods"
                (ngModelChange)="identityTypeValid = personWhoCollectedGoods?.length > 0 && identityType?.length > 0"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center mx-2 px-2">
        * Please ensure the name of the person collecting the goods matches the order details.
      </div>
      <div class="d-flex justify-content-center m-2 p-2"></div>
      <div class="modal-footer">
        <div class="m-2 p-2">
          <span class="text-danger">Note: </span> It is important that you confirm the identity of the person collecting the goods. This check will be
          recorded in the system along with your name in case of any future disputes.
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-cancel" (click)="isConfirmingIdentityForCollection = false; close()">CANCEL</button>
        <button
          type="button"
          class="btn text-white"
          [disabled]="!(personWhoCollectedGoods.toString().trim().length > 2) || !identityTypeValid || !isEcommerceOrderNumberConfirmed"
          (click)="isConfirmingIdentityForCollection = false; submitIdentityForCollection()"
        >
          SUBMIT
        </button>
      </div>
    </div>
  </div>
</ng-template>
